<template>
  <div>
    <repayments-controllers
      :repayments-selection="repaymentsSelection"
      :repayments-type-selection="repaymentsTypeSelection"
      @filterRepaymentsType="filterRepaymentsType"
      @filterRepayments="filterRepayments"/>
    <v-card>
      <search-text-field
        :search-phrase="repaymentSearch"
        :row-count="repaymentsRowCount"
        @search="repaymentSearchRefresh"
      />
      <repayments-datagrid
        :repayment-report-data="repaymentReportData"
        :repayments-loading="repaymentsLoading"
        :rows-per-page="repaymentsRowsPerPage"
        :row-count="repaymentsRowCount"
        @refreshWithSort="refreshRepaymentsWithSort"
      />
      <pagination
        :selected-page="repaymentsSelectedPage"
        :rows-per-page="repaymentsRowsPerPage"
        :row-count="repaymentsRowCount"
        @changeDisplayedRowCount="repaymentsChangeDisplayedRowCount"
        @clickedPage="changeRepaymentPage"/>
    </v-card>
  </div>
</template>

<script>
import RepaymentsDatagrid from './RepaymentsDatagrid';
import RepaymentsControllers from './RepaymentsControllers';
import Pagination from '../../controllers/Pagination.vue';
import SearchTextField from '../../controllers/SearchTextField';
    export default {
        name: "RepaymentsReport",
        components: {RepaymentsControllers,RepaymentsDatagrid,Pagination,SearchTextField},
        data ()
        {
            return {
                repaymentSearch: '',
                repaymentsLoading: false,
                repaymentsSorting: {Created:'desc'},
                repaymentsSelection: 'all',
                repaymentsTypeSelection: 'all',
                repaymentReportData: [],
                repaymentsSelectedPage: 1,
                repaymentsRowsPerPage: 5,
                repaymentsRowCount: 0,
            }
        },
        methods: {
            changeRepaymentPage (page)
            {
                let self = this;

                self.repaymentsSelectedPage = page;
                self.refreshRepaymentsReportData();
            },
            repaymentsChangeDisplayedRowCount (rowCount)
            {
              let self = this;

              self.repaymentsSelectedPage = 1;
              self.repaymentsRowsPerPage = isNaN(parseInt(rowCount))? -1 : parseInt(rowCount);
              self.refreshRepaymentsReportData();
            },
            filterRepayments (selection)
            {
                this.repaymentsSelection = selection;
                this.refreshRepaymentsReportData ();
            },
            filterRepaymentsType (selection)
            {
                this.repaymentsTypeSelection = selection;
                this.refreshRepaymentsReportData ();
            },

            refreshRepaymentsWithSort (pagination)
            {
                let self = this;

                self.repaymentsSorting = {};
                self.repaymentsSorting[pagination.sortBy] = pagination.descending ? 'desc' : 'asc';
                self.refreshRepaymentsReportData ();
            },
            repaymentSearchRefresh (search)
            {
              let self = this;

              if (search !== '')
              {
                self.repaymentsSelectedPage = 1
              }
              self.repaymentSearch = search;
              self.refreshRepaymentsReportData();
            },
            refreshRepaymentsReportData ()
            {
                let self = this;

                self.repaymentsLoading = true;
                let repaymentsFetch = self.$store.dispatch('repayments/getRepaymentsReport', {page: self.repaymentsSelectedPage, rowsPerPage: self.repaymentsRowsPerPage, selection: self.repaymentsSelection, sort: self.repaymentsSorting, type: self.repaymentsTypeSelection, search: self.repaymentSearch });
                repaymentsFetch.then(response =>
                    {
                        self.processRepaymentReportData(response);
                        self.repaymentsLoading = false;
                    }, () =>
                    {
                        // error
                        self.repaymentsLoading = false;
                    }
                );
            },
            processRepaymentReportData (obj)
            {
                let self = this;

                let repaymentReports = obj.Rows;
                self.repaymentReportData = [];
                for (let repaymentReport of repaymentReports)
                {
                    let repaymentReportClient = {
                        Amount: repaymentReport.Amount,
                        Created: repaymentReport.Created,
                        CreatedBy: repaymentReport.CreatedBy,
                        DebtorName: repaymentReport.DebtorName,
                        DebtorRegistryId: repaymentReport.DebtorRegistryId,
                        ExpirationDate: repaymentReport.ExpirationDate,
                        FactoringCount: repaymentReport.FactoringCount,
                        Id: repaymentReport.Id,
                        Status: repaymentReport.Status,
                        Type: repaymentReport.Type,
                    };
                    self.repaymentReportData.push(repaymentReportClient);
                }
                self.repaymentsRowCount = obj.TotalRowCount;
            },
        }
    }
</script>

<style scoped>

</style>
